import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SyncLoader } from 'react-spinners'
import { animate, motion, useMotionValue } from 'framer-motion'

import { TICKETSMS_COLORS_GREY_2, TICKETSMS_COLORS_RED, TICKETSMS_COLORS_WHITE } from 'utils/constants/colors'

import Img from 'components/Media/Img'

interface Props {
  onDragComplete(): void
}

const DraggableBox: React.FC<Props> = (props) => {
  const { onDragComplete } = props

  const { t } = useTranslation()

  const x = useMotionValue(-249)
  const [isDragComplete, setIsDragComplete] = useState(false)

  const MAX_LEFT = 0
  const MIN_LEFT = -249

  const handleDragEnd = () => {
    const currentX = x.get()

    if (currentX >= MAX_LEFT - 32) {
      x.set(MAX_LEFT)
      if (!isDragComplete) {
        setIsDragComplete(true)
        onDragComplete()
      }
    } else {
      animate(x, MIN_LEFT, {
        type: 'spring',
        stiffness: 300,
        damping: 25,
      })
    }
  }

  return (
    <div
      style={{
        width: 313,
        height: 64,
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: 'white',
        borderRadius: 64,
      }}
    >
      <motion.div
        drag={isDragComplete ? false : 'x'}
        dragConstraints={{ left: MIN_LEFT, right: MAX_LEFT }}
        style={{
          width: 313,
          height: 64,
          backgroundColor: TICKETSMS_COLORS_RED,
          position: 'absolute',
          zIndex: 3,
          top: 0,
          x,
          cursor: 'grab',
          borderRadius: 64,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        whileTap={{ scale: isDragComplete ? 1 : 0.97 }}
        onDragEnd={handleDragEnd}
      >
        {!isDragComplete && (
          <>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: 16,
                color: 'white',
                marginRight: 50,
                marginLeft: 70,
              }}
            >
              {t('goodsAndServices:button_use_drink')}
            </div>
            <Img
              style={{
                pointerEvents: 'none',
              }}
              src="/goodsandservices/arrow-right.svg"
            />
          </>
        )}
        {isDragComplete && (
          <div
            style={{
              position: 'absolute',
              zIndex: 3,
              top: '50%',
              left: '50%',
              transform: 'translate(-50%,-50%)',
            }}
          >
            <SyncLoader size={8} color={TICKETSMS_COLORS_WHITE} />
          </div>
        )}
      </motion.div>
      <div
        style={{
          position: 'absolute',
          zIndex: 1,
          color: TICKETSMS_COLORS_GREY_2,
          top: 0,
          left: 0,
          width: 313,
          height: 64,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          fontWeight: 'bold',
        }}
      >
        {t('goodsAndServices:drag_to_use')}
      </div>
    </div>
  )
}

export default DraggableBox
